const FeaturesConstants = {
    DRIVER_LOCATION_DASHBOARD: "driver-location-dashboard",
    ON_DEMAND_RIDER_EXP_DASHBOARD: "on-demand-rider-exp-dashboard",
    ON_DEMAND_RIDER_EXP_STORE_DASHBOARD: "on-demand-rider-exp-store-dashboard",
    CLUBBING_ENABLED_HUB_DASHBOARD: "clubbing-enabled-hub-dashboard",
    INTELLIGENT_CLUBBING_DRIVER_INDICATOR: "intelligent-clubbing-driver-indicator",
};

export default FeaturesConstants;
